import React, { PureComponent } from "react";

import find from "lodash/find";
import findIndex from "lodash/findIndex";
import get from "lodash/get";
import { readGames, getAllData, updateGames } from "helpers/api";
import { Drawer, Button } from "antd";

import "./style.css";

import Level from "./Level";
import SearchDrawer from "../Words/SearchDrawer";

class Games extends PureComponent {
  state = {
    games: [],
    allWords: [],
    language: "de",
    isDrawerVisible: false
  };

  componentDidMount = async () => {
    const { language } = this.state;
    const { games } = await readGames(language);
    this.setState({ games: games });
    const allWords = localStorage.getItem("allData");
    if (!allWords) {
      this.fetchAllLevels();
    } else {
      console.log("all levels exist in local storage");
      this.setState({ allWords: JSON.parse(allWords) });
    }
  };

  fetchAllLevels = async () => {
    this.setState({ allWords: [] });
    console.log("fetching all levels");
    const data = [];
    const response = await getAllData();
    JSON.parse(response).forEach(level => {
      level.words.forEach(word => {
        const { image, ...rest } = word;
        data.push({ ...rest, key: word.id, levelID: level.id });
      });
    });
    localStorage.setItem("allData", JSON.stringify(data));
    this.setState({ allWords: data });
  };

  handleCreateLevel = async newLevel => {
    const { games, language } = this.state;
    const newGames = [...games, newLevel];
    await updateGames(language, newGames);
    const response = await readGames(language);
    this.setState({ games: response.games });
  };

  handleUpdateLevel = async updatedLevel => {
    const { games, language } = this.state;
    const newGames = games.map(level => {
      if (level.id === updatedLevel.id) {
        return updatedLevel;
      }
      return level;
    });
    await updateGames(language, newGames);
    const response = await readGames(language);
    this.setState({ games: response.games });
  };

  drawerClose = () => {
    this.setState({ isDrawerVisible: false });
  };

  render() {
    const { games, allWords, language, isDrawerVisible } = this.state;
    if (allWords.length < 1) return null;
    let wordsInGames = [];
    games.forEach(level => {
      level.words.forEach(word => {
        wordsInGames = [...new Set([...wordsInGames, word.wordID])];
      });
    });
    return (
      <div className="Games">
        <Button onClick={() => this.setState({ isDrawerVisible: true })}>
          Open Search
        </Button>
        {games.map(level => (
          <Level
            key={level.id}
            level={level}
            language={language}
            allWords={allWords}
            onSave={this.handleUpdateLevel}
            wordsInGames={wordsInGames}
          />
        ))}
        <Level
          title="New Level"
          level={{ id: games.length + 1, words: [] }}
          language={language}
          allWords={allWords}
          onSave={this.handleCreateLevel}
          wordsInGames={wordsInGames}
        />
        <Drawer
          title="Search"
          placement="right"
          width={900}
          closable
          onClose={this.drawerClose}
          visible={isDrawerVisible}
          destroyOnClose
        >
          <SearchDrawer
            columns={["id", "de", "en", "tr"].map(key => {
              return {
                title: key,
                dataIndex: key,
                key: key
              };
            })}
            filteredWordIDs={wordsInGames}
          />
        </Drawer>
        <Button onClick={() => this.setState({ isDrawerVisible: true })}>
          Open Search
        </Button>
        <Button
          onClick={() => console.log(JSON.stringify(games))}
          style={{ marginTop: 100 }}
        >
          CONSOLE LOG GAMES
        </Button>
      </div>
    );
  }
}

export default Games;



// WEBPACK FOOTER //
// ./src/containers/Games/index.js